module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prebookOverlayHolder text-center d-flex justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "d-flex flex-column w-100 mb-5"
  }, [_c('h1', {
    staticClass: "bold"
  }, [_vm._v("This is not a final booking.")]), _vm._v(" "), _c('span', {
    staticClass: "fs-larger bold"
  }, [_vm._v("\n            If you can see this, please note that someone might be in the middle"), _c('br'), _vm._v(" of a purchase or maybe has given up.\n        ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-732d7cc6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/tools/modal/ReservationEdit/PrebookOverlay.vue
// module id = 1681
// module chunks = 0